import { gql } from "graphql-request";
import MainPhotoFragment from "queries/fragments/MainPhoto";

const RESORTS_QUERY = gql`
  ${MainPhotoFragment}
  query Resorts {
    resorts(sort: "Slug:asc") {
      id
      Name
      Slug
      CoverPhoto {
        ...MainPhoto
      }
      MainPhoto {
        ...MainPhoto
      }
    }
  }
`;

export default RESORTS_QUERY;
